export default {
  "app_id": 7749057,
  "group_id": 202313082,
  "endpoint": process.env.VUE_APP_API_ENDPOINT || "",
};
